/* @flow */

import * as React from 'react';

type Props = {
  +onVisibilityChange: (isVisible: boolean) => void,
};

const VisibilityWaypoint = ({ onVisibilityChange }: Props): React.Node => {
  const elementRef = React.useRef<HTMLElement | null>(null);

  React.useEffect(() => {
    const currentElement = elementRef.current;

    if (!currentElement) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        onVisibilityChange(entry.isIntersecting);
      },
      {
        root: null,
        // Preload horizontal lists 100px before they scroll onto the screen
        rootMargin: '100px 0px 100px 0px',
        threshold: 0,
      },
    );

    observer.observe(currentElement);

    return () => observer.disconnect();
  }, [onVisibilityChange]);

  return (
    <div
      ref={elementRef}
      style={{
        height: '100%',
        left: 0,
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: -1,
      }}
    />
  );
};

export default VisibilityWaypoint;
